import axios from 'axios';
import config from '../config';

const TOKEN_KEY = 'calum_token';

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));

const axiosInstance = axios.create({
  baseURL: config.apiUrl,
  headers: { 'Content-Type': 'application/json' },
});

// Attach the app session JWT (issued by /api/auth/verify) as a Bearer token.
axiosInstance.interceptors.request.use(
  (cfg) => {
    const token = getToken();
    if (token) cfg.headers.Authorization = `Bearer ${token}`;
    return cfg;
  },
  (error) => Promise.reject(error)
);

// On 401/403, drop the (likely expired) token so the app routes back to login.
axiosInstance.interceptors.response.use(
  (r) => r,
  (error) => {
    if ([401, 403].includes(error?.response?.status) && getToken()) {
      // only clear on auth endpoints / when a token was present
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
